import itemId from 'owa-service/lib/factory/itemId';
import conversationRequestType from 'owa-service/lib/factory/conversationRequestType';
import getConversationItemsJsonRequest from 'owa-service/lib/factory/getConversationItemsJsonRequest';
import getConversationItemsOperation from 'owa-service/lib/operation/getConversationItemsOperation';
import getConversationItemsRequest from 'owa-service/lib/factory/getConversationItemsRequest';
import { getBaseItemResponseShape } from '../utils/getItemResponseShape';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function configureResponseShape() {
    var itemResponseShape = getBaseItemResponseShape();
    itemResponseShape.ExcludeBindForInlineAttachments = true;
    itemResponseShape.CalculateOnlyFirstBody = true;
    return itemResponseShape;
}
function convertConversationSortOrder(conversationSortOrder) {
    // Note: only date order ascending is treated specially, all other values are treated as date order descending (the default).
    return conversationSortOrder == 'ChronologicalNewestOnBottom'
        ? 'DateOrderAscending'
        : 'DateOrderDescending';
}
function configureRequestBody(conversationToLoad, responseShape, conversationSortOrder, maxItemsToReturn, shouldReturnModernConversationItems) {
    return getConversationItemsRequest({
        Conversations: [conversationToLoad],
        ItemShape: responseShape,
        ShapeName: 'ItemPart',
        SortOrder: convertConversationSortOrder(conversationSortOrder),
        MaxItemsToReturn: maxItemsToReturn,
        ReturnModernConversationItems: shouldReturnModernConversationItems,
    });
}
export default function getConversationItemsService(conversationId, syncState, maxItemsToReturn, conversationSortOrder, shouldUseEmptySyncState, shouldReturnModernConversationItems, options) {
    var responseShape = configureResponseShape();
    var conversation = conversationRequestType({ ConversationId: itemId(conversationId) });
    conversation.SyncState = !shouldUseEmptySyncState ? syncState : '';
    var requestBody = configureRequestBody(conversation, responseShape, conversationSortOrder, maxItemsToReturn, shouldReturnModernConversationItems);
    var jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.RequestServerVersion = 'V2017_08_18';
    return getConversationItemsOperation(getConversationItemsJsonRequest({
        Header: jsonRequestHeader,
        Body: requestBody,
    }), options).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=getConversationItemsService.js.map